// extracted by mini-css-extract-plugin
export default {"lesson3":"Lesson3_lesson3__C5CsK"};